import ErrorTypeEnum from '../../constants/enums/ErrorTypeEnum';
import BaseMessageError from './base/BaseMessageError';

class InfoMessageError extends BaseMessageError {
  public readonly type = ErrorTypeEnum.InfoMessageError;
}

export default InfoMessageError;
